<template>
  <div class="container aboutUs_container">
    <div class="content-box">
      <div class="left-box">
        <div class="title">联系我们</div>
        <div class="content">
          <div v-for="(item, index) in leftArray" :key="index" class="box">
            <div>
              <img :src="item.icon" alt="" />
            </div>
            <div>
              <div class="name">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="title">商业合作 business</div>
        <div class="content">
          <div v-for="(items, key) in rightArray" :key="key">
            {{ items.content }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    //这里存放数据
    return {
      leftArray: [
        {
          id: 0,
          content: "关注官方微信 获得更多资讯",
          icon: require("../../assets/img/icons/wx.png"),
        },
        {
          id: 1,
          content: "E-mail：xusuqin@feng-game.com",
          icon: require("../../assets/img/icons/mail.png"),
        },
        {
          id: 2,
          content: "关注官方微博 获得更多资讯",
          icon: require("../../assets/img/icons/wb.png"),
        },
        {
          id: 3,
          content: "地址：上海市嘉定区众仁路399号1幢12层B区JT3758室",
          icon: require("../../assets/img/icons/address.png"),
        },
      ],
      rightArray: [
        { id: 0, content: "国内联运、CPS、CPA合作" },
        { id: 1, content: "媒体合作" },
        { id: 2, content: "产品海外代理" },
      ],
    };
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  methods: {},
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>
